(function() {
	'use strict';

	/**
	 * @ngdoc object
	 * @name cycle.controller:CycleCtrl
	 *
	 * @description
	 *
	 */
	angular.module('cycle').controller('CycleCtrl', CycleCtrl);

	function CycleCtrl(applicationConstants, CommonMasterData, MessageService,
			AdminCycleService, PopupManager) {
		var vm = this;
		vm.ctrlName = 'CycleCtrl';

		vm.model = {
			searchCriteria : {
				showAll : false
			},
			masterList : {
				showNewCycleAddRow : false,
				newCycleToAdd : AdminCycleService.getCycleDTO()
			},
			adminCycles : [],// grid data
			cycleSearchAdaptedDTO : null,
			deleteItem : null
		};

		// load Cycles
		function loadCycles() {
			AdminCycleService
					.loadAdminCycles(
							vm.model.searchCriteria.showAll,
							function(response) {
								// set search adapted data
								vm.model.cycleSearchAdaptedDTO = AdminCycleService
										.getAdaptedCycleSearchDTO(response);
								// set admin cycles
								vm.model.adminCycles = vm.model.cycleSearchAdaptedDTO.cycleList;
								updateNewCycleToAdd();
							}, function() {
								console.log('Admin Cycles retrieval error');
							});
		}

		// set values to the newly adding cycle
		function updateNewCycleToAdd() {
			if (!!vm.model.cycleSearchAdaptedDTO) {
				vm.model.masterList.newCycleToAdd.cycleName = null;
				vm.model.masterList.newCycleToAdd.dateFrom = vm.model.cycleSearchAdaptedDTO.nextRecordsMonthFrom;
				vm.model.masterList.newCycleToAdd.dateTo = vm.model.cycleSearchAdaptedDTO.nextRecordsMonthTo;
				vm.model.masterList.newCycleToAdd.bidDeadline = vm.model.cycleSearchAdaptedDTO.nextRecordsBidDeadline;
				vm.model.masterList.newCycleToAdd.crewGroupCode = vm.model.cycleSearchAdaptedDTO.nextRecordsCrewGroupCode;
				vm.model.masterList.newCycleToAdd.crewGroups = vm.model.cycleSearchAdaptedDTO.nextRecordsCrewGroups;
				vm.model.masterList.newCycleToAdd.isValid = true;
			} else {
				loadCycles();
			}
		}

		// set initial values for newly adding cycle
		vm.clickOnNewCycle = function() {
			vm.model.masterList.showNewCycleAddRow = !vm.model.masterList.showNewCycleAddRow;
			updateNewCycleToAdd();
		};

		// when row is selected
		vm.selectAAdminCycelRow = function(selectedRowData, flag) {
			if (flag == 'delete') {
				deleteRosterCycle(selectedRowData);
			}else if (flag == 'edit'){
			  var param = {};
			  param.cycleId = selectedRowData.cycleId;
        param.cycleName = selectedRowData.cycleName;
        param.dateFrom = selectedRowData.dateFrom;
        param.dateTo = selectedRowData.dateTo;
        param.fcBidDeadlineDate = (selectedRowData.fcBidDeadline != null ? selectedRowData.fcBidDeadline.split(' ')[0] : '');
        param.ccBidDeadlineDate = (selectedRowData.ccBidDeadline != null ? selectedRowData.ccBidDeadline.split(' ')[0] : '');
        param.insBidDeadlineDate = (selectedRowData.insBidDeadline != null ? selectedRowData.insBidDeadline.split(' ')[0] : '');
        param.fcBidDeadlineTime = (selectedRowData.fcBidDeadline != null ? selectedRowData.fcBidDeadline.split(' ')[1] : '');
        param.ccBidDeadlineTime = (selectedRowData.ccBidDeadline != null ? selectedRowData.ccBidDeadline.split(' ')[1] : '');
        param.insBidDeadlineTime = (selectedRowData.insBidDeadline != null ? selectedRowData.insBidDeadline.split(' ')[1] : '');
        param.crewGroupCode = selectedRowData.crewGroupCode;
        param.version = selectedRowData.version;
        PopupManager.openModal('EDIT_ROSTER_CYCLE', param, onCloseEditRosterCycle);
			} else if (flag == 'add') {
				if (!!!vm.model.masterList.newCycleToAdd.cycleName
						|| vm.model.masterList.newCycleToAdd.cycleName == null
						|| vm.model.masterList.newCycleToAdd.cycleName == "") {
					vm.model.masterList.newCycleToAdd.isValid = false;
				} else {
					vm.model.masterList.newCycleToAdd.isValid = true;
					saveNewlyAddedCycle();
				}
			} else if (flag == 'clear') {
				updateNewCycleToAdd();
			}
		};
		function onCloseEditRosterCycle() {
		  loadCycles();
		}

		//add new cycle
		function saveNewlyAddedCycle() {
			var saveCycleReq = AdminCycleService
					.setSaveCycleRequest(vm.model.masterList.newCycleToAdd);
			saveCycleReq.operation = 'CREATE';
			AdminCycleService
					.saveAdminCycle(
							saveCycleReq,
							function(response) {
								// if success
								if (response.success) {
									MessageService
											.success('Admin Cycle is Successfully saved!');
									updateNewCycleToAdd();
									vm.model.masterList.showNewCycleAddRow = !vm.model.masterList.showNewCycleAddRow;
								} else if (!response.success) {
									MessageService.error(response.error);
								}
								loadCycles();
							}, function(error) {
								MessageService.error(error[0]);
								loadCycles();
							});
		}
		;
    function deleteRosterCycle(selectedItem){
      vm.model.deleteItem = selectedItem;
      var param = {
          title: 'Confirmation',
          messages: ["Do you want to delete this record"],
          item: selectedItem
      };
      PopupManager.openModal('CONFIRM_DIALOG', param, confirmDeleteDialog);
    }


    function confirmDeleteDialog(pass) {
        if(pass==='YES'){
        	deleteCycle(vm.model.deleteItem);
        }else{
          vm.model.deleteItem = null;
        }
    }
		//delete cycle
		function deleteCycle(selectedRowData) {
			var deleteCycleReq = AdminCycleService
					.setDeleteCycleRequest(selectedRowData);
			AdminCycleService.deleteAdminCycle(deleteCycleReq, function(
					response) {
				// if success
				if (response.success) {
					MessageService
							.success('Admin Cycle is Successfully deleted!');
				} else if (!response.success) {
					MessageService.error(response.error);
				}
				vm.model.deleteItem = null;
				loadCycles();
			}, function(error) {
				MessageService.error(error[0]);
				loadCycles();
			});
		}
		;

		// initial Load data
		loadCycles();
	}
}());
